import { am } from './utils';

import httpClient from '@/utils/httpClient';

const logger = console;

const INITIALIZE = am(`INITIALIZE`);
const SYNC_MARK = am(`SYNC_MARK`);
const SYNC_DELETE = am(`SYNC_DELETE`);
const GET_COLLECTION = am(`GET_USPTO_MIRROR_COLLECTION`);
const CREATE = am(`CREATE_USPTO_MIRROR_PROCESSING`);
const DELETE = am(`DELETE_USPTO_MIRROR_PROCESSING`);

const UPDATE_PROCESSING = am(`UPDATE_USPTO_MIRROR`);

const GET_SCHEDULE = am(`GET_SCHEDULE`);
const UPDATE_SCHEDULE = am(`UPDATE_SCHEDULE`);
const GET_REQUEST_TIMEOUT = am(`GET_REQUEST_TIMEOUT`);
const UPDATE_REQUEST_TIMEOUT = am(`UPDATE_REQUEST_TIMEOUT`);
const GET_DOWNLOAD_REPEAT = am(`GET_DOWNLOAD_REPEAT`);
const UPDATE_DOWNLOAD_REPEAT = am(`UPDATE_DOWNLOAD_REPEAT`);
const GET_TOO_MANY_REQUESTS_DELAY = am(`GET_TOO_MANY_REQUESTS_DELAY`);
const UPDATE_TOO_MANY_REQUESTS_DELAY = am(`UPDATE_TOO_MANY_REQUESTS_DELAY`);
const SYNC_CUSTOMER_NUMBERS = am(`SYNC_CUSTOMER_NUMBERS`);

const state = {
  isGetCollectionRequestPending: false,
  isGetCollectionRequestFailed: false,

  isCreateRequestPending: false,
  isCreateRequestFailed: false,

  isDeleteRequestPending: false,
  isDeleteRequestFailed: false,

  isSyncRequestPending: false,
  isSyncRequestFailed: false,

  isSyncDeleteRequestPending: false,
  isSyncDeleteRequestFailed: false,

  collection: [],
  total: 0,
  size: 0,
  from: 0,
  aggs: null,
  aggsCustomers: null,

  cronJobTimer: null,
  downloadPauseTime: null,

  isReady: false,
  active: null,
  syncInProgress: false,
  toDelete: [],

  isGetScheduleRequestPending: false,
  isGetScheduleRequestFailed: false,
  isUpdateScheduleRequestPending: false,
  isUpdateScheduleRequestFailed: false,

  isGetRequestTimeoutRequestPending: false,
  isGetRequestTimeoutRequestFailed: false,
  isUpdateRequestTimeoutRequestPending: false,
  isUpdateRequestTimeoutRequestFailed: false,

  isGetDownloadRepeatRequestPending: false,
  isGetDownloadRepeatRequestFailed: false,
  isUpdateDownloadRepeatRequestPending: false,
  isUpdateDownloadRepeatRequestFailed: false,

  isGetTooManyRequestsDelayRequestPending: false,
  isGetTooManyRequestsDelayRequestFailed: false,
  isUpdateTooManyRequestsDelayRequestPending: false,
  isUpdateTooManyRequestsDelayRequestFailed: false,

  isSyncCustomerNumbersRequestPending: false,
  isSyncCustomerNumbersRequestFailed: false,

  schedule: null,
  requestTimeout: null,
  downloadRepeat: null,
  tooManyRequestsDelay: null
};

const mutations = {
  [INITIALIZE.STARTED](state) {
    // state.isReady = false;
    // state.active = null;
    state.jobs = null;
  },
  [INITIALIZE.COMPLETED](state, { active, jobs, toDelete, syncInProgress }) {
    state.isReady = true;
    state.active = active;
    state.jobs = jobs;
    state.toDelete = toDelete;
    state.syncInProgress = syncInProgress;
  },
  [SYNC_MARK.STARTED](state) {
    state.isSyncRequestPending = true;
    state.isSyncRequestFailed = false;
    state.syncInProgress = true;
  },
  [SYNC_MARK.COMPLETED](state) {
    state.isSyncRequestPending = false;
    state.isSyncRequestFailed = false;
    state.syncInProgress = false;
  },
  [SYNC_MARK.FAILED](state) {
    state.isSyncRequestPending = false;
    state.isSyncRequestFailed = true;
  },
  [SYNC_DELETE.STARTED](state) {
    state.isSyncRequestPending = true;
    state.isSyncRequestFailed = false;
  },
  [SYNC_DELETE.COMPLETED](state) {
    state.isSyncRequestPending = false;
    state.isSyncRequestFailed = false;
  },
  [SYNC_DELETE.FAILED](state) {
    state.isSyncRequestPending = false;
    state.isSyncRequestFailed = true;
  },
  [GET_COLLECTION.STARTED](state) {
    state.isGetCollectionRequestPending = true;
    state.isGetCollectionRequestFailed = false;
  },
  [GET_COLLECTION.FAILED](state) {
    state.isGetCollectionRequestPending = false;
    state.isGetCollectionRequestFailed = true;
  },
  [GET_COLLECTION.COMPLETED](state, collection) {
    state.isGetCollectionRequestPending = false;
    state.collection = [...collection.data];
    state.aggs = collection.aggs;
    state.aggsCustomers = collection.aggsCustomers;
    state.total = collection.total;
    state.size = collection.size;
    state.from = collection.from;
  },

  [CREATE.STARTED](state) {
    state.isCreateRequestPending = true;
    state.isCreateRequestFailed = false;
  },
  [CREATE.FAILED](state) {
    state.isCreateRequestPending = false;
    state.isCreateRequestFailed = true;
  },
  [CREATE.COMPLETED](state, collection) {
    state.isCreateRequestPending = false;
    for (const item of collection) {
      const existing = state.collection.find(e => e.id === item.id);
      if (existing) {
        existing.status = item.status;
        existing.updatedAt = item.updatedAt;
        existing.message = item.message;
      }
    }
  },

  [DELETE.STARTED](state) {
    state.isDeleteRequestPending = true;
    state.isDeleteRequestFailed = false;
  },
  [DELETE.FAILED](state) {
    state.isDeleteRequestPending = false;
    state.isDeleteRequestFailed = true;
  },
  [DELETE.COMPLETED](state, id) {
    state.isDeleteRequestPending = false;
    const index = state.collection.findIndex(t => t.id === id);
    if (index) {
      state.collection.splice(index, 1);
    }
    if (state.item && state.item.id === id) {
      state.item = null;
    }
  },

  [UPDATE_PROCESSING.COMPLETED](state, { active }) {
    state.active = active;
  },

  [GET_SCHEDULE.STARTED](state) {
    state.isGetScheduleRequestPending = true;
    state.isGetScheduleRequestFailed = false;
  },
  [GET_SCHEDULE.COMPLETED](state, schedule) {
    state.isGetScheduleRequestPending = false;
    state.schedule = schedule;
  },
  [GET_SCHEDULE.FAILED](state) {
    state.isGetScheduleRequestPending = false;
    state.isGetScheduleRequestFailed = true;
  },

  [UPDATE_SCHEDULE.STARTED](state) {
    state.isUpdateScheduleRequestPending = true;
    state.isUpdateScheduleRequestFailed = false;
  },
  [UPDATE_SCHEDULE.COMPLETED](state, schedule) {
    state.isUpdateScheduleRequestPending = false;
    state.schedule = { ...state.schedule, current: schedule.newSchedule };
  },
  [UPDATE_SCHEDULE.FAILED](state) {
    state.isUpdateScheduleRequestPending = false;
    state.isUpdateScheduleRequestFailed = true;
  },

  [GET_REQUEST_TIMEOUT.STARTED](state) {
    state.isGetRequestTimeoutRequestPending = true;
    state.isGetRequestTimeoutRequestFailed = false;
  },
  [GET_REQUEST_TIMEOUT.COMPLETED](state, requestTimeout) {
    state.isGetRequestTimeoutRequestPending = false;
    state.requestTimeout = requestTimeout;
  },
  [GET_REQUEST_TIMEOUT.FAILED](state) {
    state.isGetRequestTimeoutRequestPending = false;
    state.isGetRequestTimeoutRequestFailed = true;
  },

  [UPDATE_REQUEST_TIMEOUT.STARTED](state) {
    state.isUpdateRequestTimeoutRequestPending = true;
    state.isUpdateRequestTimeoutRequestFailed = false;
  },
  [UPDATE_REQUEST_TIMEOUT.COMPLETED](state, requestTimeout) {
    state.isUpdateRequestTimeoutRequestPending = false;
    state.requestTimeout = { ...state.requestTimeout, current: requestTimeout.newTimeout };
  },
  [UPDATE_REQUEST_TIMEOUT.FAILED](state) {
    state.isUpdateRequestTimeoutRequestPending = false;
    state.isUpdateRequestTimeoutRequestFailed = true;
  },

  [GET_DOWNLOAD_REPEAT.STARTED](state) {
    state.isGetDownloadRepeatRequestPending = true;
    state.isGetDownloadRepeatRequestFailed = false;
  },
  [GET_DOWNLOAD_REPEAT.COMPLETED](state, downloadRepeat) {
    state.isGetDownloadRepeatRequestPending = false;
    state.downloadRepeat = downloadRepeat;
  },
  [GET_DOWNLOAD_REPEAT.FAILED](state) {
    state.isGetDownloadRepeatRequestPending = false;
    state.isGetDownloadRepeatRequestFailed = true;
  },

  [UPDATE_DOWNLOAD_REPEAT.STARTED](state) {
    state.isUpdateDownloadRepeatRequestPending = true;
    state.isUpdateDownloadRepeatRequestFailed = false;
  },
  [UPDATE_DOWNLOAD_REPEAT.COMPLETED](state, downloadRepeat) {
    state.isUpdateDownloadRepeatRequestPending = false;
    state.downloadRepeat = { ...state.downloadRepeat, current: downloadRepeat.newInterval };
  },
  [UPDATE_DOWNLOAD_REPEAT.FAILED](state) {
    state.isUpdateDownloadRepeatRequestPending = false;
    state.isUpdateDownloadRepeatRequestFailed = true;
  },

  [GET_TOO_MANY_REQUESTS_DELAY.STARTED](state) {
    state.isGetTooManyRequestsDelayRequestPending = true;
    state.isGetTooManyRequestsDelayRequestFailed = false;
  },
  [GET_TOO_MANY_REQUESTS_DELAY.COMPLETED](state, tooManyRequestsDelay) {
    state.isGetTooManyRequestsDelayRequestPending = false;
    state.tooManyRequestsDelay = tooManyRequestsDelay;
  },
  [GET_TOO_MANY_REQUESTS_DELAY.FAILED](state) {
    state.isGetTooManyRequestsDelayRequestPending = false;
    state.isGetTooManyRequestsDelayRequestFailed = true;
  },

  [UPDATE_TOO_MANY_REQUESTS_DELAY.STARTED](state) {
    state.isUpdateTooManyRequestsDelayRequestPending = true;
    state.isUpdateTooManyRequestsDelayRequestFailed = false;
  },
  [UPDATE_TOO_MANY_REQUESTS_DELAY.COMPLETED](state, tooManyRequestsDelay) {
    state.isUpdateTooManyRequestsDelayRequestPending = false;
    state.tooManyRequestsDelay = { ...state.tooManyRequestsDelay, current: tooManyRequestsDelay.newDelay };
  },
  [UPDATE_TOO_MANY_REQUESTS_DELAY.FAILED](state) {
    state.isUpdateTooManyRequestsDelayRequestPending = false;
    state.isUpdateTooManyRequestsDelayRequestFailed = true;
  },

  [SYNC_CUSTOMER_NUMBERS.STARTED](state) {
    state.isSyncCustomerNumbersRequestPending = true;
    state.isSyncCustomerNumbersRequestFailed = false;
  },
  [SYNC_CUSTOMER_NUMBERS.COMPLETED](state) {
    state.isSyncCustomerNumbersRequestPending = false;
  },
  [SYNC_CUSTOMER_NUMBERS.FAILED](state) {
    state.isSyncCustomerNumbersRequestPending = false;
    state.isSyncCustomerNumbersRequestFailed = true;
  }
};

const actions = {
  async initialize({ commit }) {
    commit(INITIALIZE.STARTED);
    try {
      const result = await Promise.all([
        httpClient.get(`/api/uspto/downloads/status`),
        httpClient.get(`/api/uspto/sync`),
        httpClient.get(`/api/uspto/sync/status`)
      ]);
      const response = result[0];
      const itemsToDelete = result[1];
      const syncInProgress = result[2].inProgress;

      commit(INITIALIZE.COMPLETED, { ...response, toDelete: itemsToDelete, syncInProgress });
    } catch (e) {
      logger.error(e);
    }
  },
  async syncDelete({ commit }) {
    commit(SYNC_DELETE.STARTED);
    try {
      const result = await httpClient.post(`/api/uspto/sync/delete`);
      commit(SYNC_DELETE.COMPLETED);
      return result;
    } catch (e) {
      logger.error(e);
      commit(SYNC_DELETE.FAILED);
    }

    return {};
  },
  async syncMark({ commit }) {
    commit(SYNC_MARK.STARTED);
    try {
      const result = await httpClient.post(`/api/uspto/sync/mark`);
      commit(SYNC_MARK.COMPLETED);
      return result;
    } catch (e) {
      logger.error(e);
      commit(SYNC_MARK.FAILED);
    }

    return {};
  },
  async create({ commit }, { applications }) {
    commit(CREATE.STARTED);
    try {
      const response = await httpClient.post(`/api/uspto/downloads/`, { collection: applications });
      commit(CREATE.COMPLETED, response);

      return response;
    } catch (e) {
      commit(CREATE.FAILED);
      logger.error(e);
    }
  },

  async update({ commit }, { id, priority }) {
    try {
      const response = await httpClient.put(`/api/uspto/downloads/${encodeURIComponent(id)}`, { priority });
      commit(CREATE.COMPLETED, [response]);

      return response;
    } catch (e) {
      logger.error(e);
      throw e;
    }
  },

  async delete({ commit }, id) {
    commit(DELETE.STARTED);
    try {
      await httpClient.delete(`/api/uspto/downloads/${encodeURIComponent(id)}`);
      commit(DELETE.COMPLETED, id);
    } catch (e) {
      commit(DELETE.FAILED);
      logger.error(e);
    }
  },

  async getCollection({ commit }, payload) {
    commit(GET_COLLECTION.STARTED);
    try {
      const { data, total, aggs, aggsCustomers } = await httpClient.post(`/api/uspto/downloads/sorted`, payload);
      commit(GET_COLLECTION.COMPLETED, {
        data,
        total,
        aggs,
        aggsCustomers
      });
    } catch (e) {
      commit(GET_COLLECTION.FAILED);
      logger.error(e);
    }
  },

  async pause({ commit }) {
    try {
      await httpClient.post(`/api/uspto/downloads/pause`);
      commit(UPDATE_PROCESSING.COMPLETED, { active: false });
    } catch (e) {
      logger.error(e);
    }
  },
  async resume({ commit }) {
    try {
      await httpClient.post(`/api/uspto/downloads/resume`);
      commit(UPDATE_PROCESSING.COMPLETED, { active: true });
    } catch (e) {
      logger.error(e);
    }
  },

  async getSchedule({ commit }) {
    commit(GET_SCHEDULE.STARTED);
    try {
      const response = await httpClient.get(`/api/uspto/config/schedule`);
      commit(GET_SCHEDULE.COMPLETED, response);
      return response;
    } catch (e) {
      commit(GET_SCHEDULE.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async updateSchedule({ commit }, newCron) {
    commit(UPDATE_SCHEDULE.STARTED);
    try {
      const response = await httpClient.post(`/api/uspto/config/schedule`, { newCron });
      commit(UPDATE_SCHEDULE.COMPLETED, response);
      return response;
    } catch (e) {
      commit(UPDATE_SCHEDULE.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async getRequestTimeout({ commit }) {
    commit(GET_REQUEST_TIMEOUT.STARTED);
    try {
      const response = await httpClient.get(`/api/uspto/config/request-timeout`);
      const converted = {
        current: response.current * 60 * 1000,
        default: response.default * 60 * 1000
      };
      commit(GET_REQUEST_TIMEOUT.COMPLETED, converted);
      return converted;
    } catch (e) {
      commit(GET_REQUEST_TIMEOUT.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async updateRequestTimeout({ commit }, timeoutMs) {
    commit(UPDATE_REQUEST_TIMEOUT.STARTED);
    try {
      const timeoutMinutes = Math.round(timeoutMs / (60 * 1000));
      const response = await httpClient.post(`/api/uspto/config/request-timeout`, { timeoutMinutes });
      commit(UPDATE_REQUEST_TIMEOUT.COMPLETED, response);
      return response;
    } catch (e) {
      commit(UPDATE_REQUEST_TIMEOUT.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async getDownloadRepeat({ commit }) {
    commit(GET_DOWNLOAD_REPEAT.STARTED);
    try {
      const response = await httpClient.get(`/api/uspto/config/download-repeat`);
      commit(GET_DOWNLOAD_REPEAT.COMPLETED, response);
      return response;
    } catch (e) {
      commit(GET_DOWNLOAD_REPEAT.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async updateDownloadRepeat({ commit }, intervalMs) {
    commit(UPDATE_DOWNLOAD_REPEAT.STARTED);
    try {
      const response = await httpClient.post(`/api/uspto/config/download-repeat`, { intervalMs });
      commit(UPDATE_DOWNLOAD_REPEAT.COMPLETED, response);
      return response;
    } catch (e) {
      commit(UPDATE_DOWNLOAD_REPEAT.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async getTooManyRequestsDelay({ commit }) {
    commit(GET_TOO_MANY_REQUESTS_DELAY.STARTED);
    try {
      const response = await httpClient.get(`/api/uspto/config/too-many-requests-delay`);
      commit(GET_TOO_MANY_REQUESTS_DELAY.COMPLETED, response);
      return response;
    } catch (e) {
      commit(GET_TOO_MANY_REQUESTS_DELAY.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async updateTooManyRequestsDelay({ commit }, delayMs) {
    commit(UPDATE_TOO_MANY_REQUESTS_DELAY.STARTED);
    try {
      const response = await httpClient.post(`/api/uspto/config/too-many-requests-delay`, { delayMs });
      commit(UPDATE_TOO_MANY_REQUESTS_DELAY.COMPLETED, response);
      return response;
    } catch (e) {
      commit(UPDATE_TOO_MANY_REQUESTS_DELAY.FAILED);
      logger.error(e);
      throw e;
    }
  },

  async syncCustomerNumbers({ commit }) {
    commit(SYNC_CUSTOMER_NUMBERS.STARTED);
    try {
      const response = await httpClient.post(`/api/uspto/sync/customer-numbers`);
      commit(SYNC_CUSTOMER_NUMBERS.COMPLETED);
      return response;
    } catch (e) {
      commit(SYNC_CUSTOMER_NUMBERS.FAILED);
      logger.error(e);
      throw e;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
